module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"app-name":"EZMeals","message":{"hello":"hello world"}},"zh-tw":{"app-name":"EZMeals","message":{"hello":"chinese hello"}}}')
  delete Component.options._Ctor
}
